import { getUnixTime } from "date-fns";

export function getUnixTimeFromStartDay(date = new Date()) {
  return getUnixTime(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())));
}

export function getCurrentDay(date = new Date()) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export function validateUnixTime(date) {
  return /^\d+$/.test(date);
}
